import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function NotFound() {
  return (
    <Box sx={{ textAlign: "center", py: 10 }}>
      <Typography variant="h3" gutterBottom>
        404
      </Typography>
      <Typography variant="h6" paragraph>
        Página no encontrada.
      </Typography>
      <Button
        component={RouterLink}
        to="/"
        variant="contained"
        sx={{ bgcolor: "#e06a00", "&:hover": { bgcolor: "#cc5f00" } }}
      >
        Volver al inicio
      </Button>
    </Box>
  );
}
